module.exports = __webpack_public_path__ + "img/spotify-color.9b042b44.webp";